import { GenericState, NonNullableGenericState } from '../models';

const setLoading = <T, K = GenericState<T> | NonNullableGenericState<T>>(state: K): K => ({
    ...state,
    status: 'loading'
});

const setSuccess = <T, K = GenericState<T> | NonNullableGenericState<T>>(state: K, data: T): K => ({
    ...state,
    data,
    status: 'success',
    error: null
});

const setFailed = <T, K = GenericState<T> | NonNullableGenericState<T>>(state: K, { error }: { error: string }): K => ({
    ...state,
    status: 'error',
    error
});

export const ReducerUtil = { setLoading, setSuccess, setFailed };
